import React from 'react';
import { Modal, Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import LockIcon from '@mui/icons-material/Lock';
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MapIcon from '@mui/icons-material/Map';
import WifiIcon from '@mui/icons-material/Wifi';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import PublicIcon from '@mui/icons-material/Public';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const fieldMap = [
  { key: 'site_code', label: 'Site Code', icon: <LocationOnIcon color="action" /> },
  { key: 'physical', label: 'Physical', icon: <BusinessIcon color="action" /> },
  { key: 'region', label: 'Region', icon: <MapIcon color="action" /> },
  { key: 'vendor', label: 'Vendor', icon: <ApartmentIcon color="action" /> },
  { key: 'site_status', label: 'Status', icon: <InfoIcon color="action" /> },
  { key: 'site_type', label: 'Type', icon: <BusinessIcon color="action" /> },
  { key: 'lat', label: 'Latitude', icon: <PublicIcon color="action" /> },
  { key: 'long', label: 'Longitude', icon: <PublicIcon color="action" /> },
  { key: '2g', label: '2G', icon: <SignalCellularAltIcon color="action" /> },
  { key: '2g_cells', label: '2G Cells', icon: <SignalCellularAltIcon color="action" /> },
  { key: '2g_locked_tag', label: '2G Locked Tag', icon: <LockIcon color="action" /> },
  { key: '4g', label: '4G', icon: <WifiIcon color="action" /> },
  { key: '4g_cells', label: '4G Cells', icon: <WifiIcon color="action" /> },
  { key: '4g_locked_tag', label: '4G Locked Tag', icon: <LockIcon color="action" /> },
  { key: 'site_from', label: 'Site From', icon: <PersonIcon color="action" /> },
  { key: 'site_to', label: 'Site To', icon: <PersonIcon color="action" /> },
  { key: 'commercial_city', label: 'Commercial City', icon: <MapIcon color="action" /> },
  { key: 'commercial_district', label: 'Commercial District', icon: <MapIcon color="action" /> },
  { key: 'commercial_region', label: 'Commercial Region', icon: <MapIcon color="action" /> },
  {
    key: 'commercial_subregion',
    label: 'Commercial Subregion',
    icon: <MapIcon color="action" />,
  },
  { key: 'city_prefix_based', label: 'City Prefix', icon: <MapIcon color="action" /> },
  { key: 'usf_site', label: 'USF Site', icon: <CheckCircleIcon color="action" /> },
  { key: 'pta_district', label: 'PTA District', icon: <MapIcon color="action" /> },
  { key: 'pta_province', label: 'PTA Province', icon: <MapIcon color="secondary" /> },
  { key: 'pta_tehsil', label: 'PTA Tehsil', icon: <MapIcon color="action" /> },
  { key: 'mbu', label: 'MBU', icon: <BusinessIcon color="action" /> },
  { key: 'locked_status', label: 'Locked Status', icon: <LockIcon color="action" /> },
  { key: 'scope', label: 'Scope', icon: <InfoIcon color="action" /> },
  { key: 'sharing_type_hostguest', label: 'Sharing Type', icon: <InfoIcon color="action" /> },
  { key: 'site_status', label: 'Site Status', icon: <InfoIcon color="action" /> },
  { key: 'reason', label: 'Reason', icon: <InfoIcon color="action" /> },
  { key: 'archived', label: 'Archived', icon: <CancelIcon color="action" /> },
  { key: 'archived_type', label: 'Archived Type', icon: <CancelIcon color="action" /> },
  { key: 'b2s_id', label: 'B2S ID', icon: <InfoIcon color="action" /> },
  { key: 'bsc', label: 'BSC', icon: <InfoIcon color="action" /> },
  { key: 'bsc_code', label: 'BSC Code', icon: <InfoIcon color="action" /> },
  { key: 'franchise_id', label: 'Franchise ID', icon: <InfoIcon color="action" /> },
  { key: 'id', label: 'ID', icon: <InfoIcon color="action" /> },
  { key: 'part_of_dec_cfo', label: 'Part of Dec CFO', icon: <InfoIcon color="action" /> },
  { key: 'prefix', label: 'Prefix', icon: <InfoIcon color="action" /> },
  { key: 'total_trx', label: 'Total TRX', icon: <SignalCellularAltIcon color="action" /> },
  { key: '900_trx', label: '900 TRX', icon: <SignalCellularAltIcon color="action" /> },
  { key: '1800_trx', label: '1800 TRX', icon: <SignalCellularAltIcon color="action" /> },
  { key: 'l900a_cells', label: 'L900A Cells', icon: <WifiIcon color="action" /> },
  { key: 'l1800a_cells', label: 'L1800A Cells', icon: <WifiIcon color="action" /> },
  { key: 'l1800b_cells', label: 'L1800B Cells', icon: <WifiIcon color="action" /> },
  { key: 'l2100_cells', label: 'L2100 Cells', icon: <WifiIcon color="action" /> },
  { key: 'mmcells', label: 'MM Cells', icon: <WifiIcon color="action" /> },
  { key: 'total_l18_ab_cells', label: 'Total L18 AB Cells', icon: <WifiIcon color="action" /> },
  { key: 'commercial_city', label: 'Commercial City', icon: <MapIcon color="action" /> },
  { key: 'commercial_district', label: 'Commercial District', icon: <MapIcon color="action" /> },
  { key: 'commercial_region', label: 'Commercial Region', icon: <MapIcon color="action" /> },
  {
    key: 'commercial_subregion',
    label: 'Commercial Subregion',
    icon: <MapIcon color="action" />,
  },
  { key: 'technical_city', label: 'Technical City', icon: <MapIcon color="action" /> },
  { key: 'site_from', label: 'Site From', icon: <PersonIcon color="action" /> },
  { key: 'site_to', label: 'Site To', icon: <PersonIcon color="action" /> },
];

export default function RanDbSiteDetailsModal({ open, onClose, site }) {
  if (!site) {
    return null;
  }
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          p: 4,
          background: '#fff',
          borderRadius: 2,
          maxWidth: 1000,
          width: '95vw',
          mx: 'auto',
          my: 8,
          boxShadow: 24,
          position: 'relative',
          maxHeight: { xs: '90vh', sm: '80vh' },
          overflowY: 'auto',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" gutterBottom align="center">
          Site Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {fieldMap.map(
            ({ key, label, icon }) =>
              site[key] !== undefined && (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Box
                    display="flex"
                    alignItems="center"
                    bgcolor="#fafafa"
                    borderRadius={1}
                    p={1.5}
                    mb={1}
                    border="1px solid #e0e0e0"
                  >
                    {icon}
                    <Typography variant="subtitle2" sx={{ ml: 1, minWidth: 120 }}>
                      {label}:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 1,
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: '200px',
                      }}
                      title={
                        site[key] === null || site[key] === undefined ? '-' : String(site[key])
                      }
                    >
                      {site[key] === null || site[key] === undefined ? '-' : String(site[key])}
                    </Typography>
                  </Box>
                </Grid>
              )
          )}
        </Grid>
      </Box>
    </Modal>
  );
}
